const handleFacetValuesForDesktop = (facetValuesArray, currentFacetValue) => {
  const facetValuesSet = new Set([...facetValuesArray])
  const action = facetValuesSet.has(currentFacetValue) ? 'delete' : 'add'
  facetValuesSet[action](currentFacetValue)
  return [...facetValuesSet]
}

const handleRefinementList = (selectedFacets, searchState = { refinementList: {} }, isMobile) => {
  if (selectedFacets?.length === 0) return []
  return selectedFacets.reduce(
    (refinementListResult, currentFacet) => {
      const currentFacetValue = currentFacet.facetValue
      const selectedFacetKey = currentFacet.facetId || currentFacet.facet
      const refinementListFacetValue = refinementListResult[selectedFacetKey]

      if (isMobile) {
        return { ...refinementListResult, [selectedFacetKey]: refinementListFacetValue }
      }

      if (!refinementListResult[selectedFacetKey]) {
        return { ...refinementListResult, [selectedFacetKey]: [currentFacetValue] }
      }

      const facetValuesArray = handleFacetValuesForDesktop(refinementListFacetValue, currentFacetValue)
      return { ...refinementListResult, [selectedFacetKey]: facetValuesArray }
    },
    { ...searchState.refinementList }
  )
}

export { handleRefinementList, handleFacetValuesForDesktop }
